// AGB, Text vom Kunden übernommen.
export const AGB = {
  intro: ["Allgemeine Geschäftsbedingungen (AGB)"],
  sections: [
    { h: "1. Geltungsbereich", items: ["Diese Allgemeinen Geschäftsbedingungen gelten für alle Schwimmkurse der Schwimmschule Manta."] },
    {
      h: "2. Anmeldung und Vertragsabschluss",
      items: [
        "Die Anmeldung zu einem Kurs erfolgt über das Anmeldeformular, per E-Mail oder über andere angebotene Kontaktmöglichkeiten.",
        "Mit der Anmeldebestätigung wird ein Kursplatz für den Teilnehmer reserviert. Der Vertrag kommt erst mit vollständigem Eingang der Kursgebühr zustande. Erst nach Zahlungseingang gilt der Kursplatz als verbindlich bestätigt.",
      ],
    },
    {
      h: "3. Kursgebühren",
      items: [
        "Die Kursgebühr ist vor Kursbeginn vollständig zu bezahlen. Die Zahlungsinformationen werden mit der Anmeldebestätigung mitgeteilt.",
        "Erfolgt die Zahlung nicht innerhalb der angegebenen Zahlungsfrist, behält sich die Schwimmschule Manta vor, den reservierten Kursplatz anderweitig zu vergeben.",
      ],
    },
    {
      h: "4. Teilnahmebedingungen",
      items: [
        "Die Teilnahme ist nur möglich, wenn der Gesundheitszustand des Kindes die Teilnahme am Schwimmunterricht erlaubt.",
        "Die Erziehungsberechtigten informieren die Schwimmschule über relevante gesundheitliche Einschränkungen.",
      ],
    },
    {
      h: "5. Fehlzeiten",
      items: [
        "Kann ein Teilnehmer aus persönlichen Gründen nicht am Kurs teilnehmen, besteht grundsätzlich kein Anspruch auf Ersatzstunden oder Rückerstattung der Kursgebühr.",
        "Dies gilt auch bei Krankheit, Verletzung oder einer längerfristigen Erkrankung sowie bei einem vorzeitigen Abbruch des Kurses durch den Teilnehmer. Eine Rückerstattung der Kursgebühr ist ausgeschlossen.",
      ],
    },
    { h: "6. Ausfall von Kursstunden", items: ["Sollte eine Kursstunde durch die Schwimmschule abgesagt werden müssen, wird nach Möglichkeit ein Ersatztermin angeboten."] },
    {
      h: "7. Aufsichtspflicht",
      items: [
        "Die Aufsichtspflicht der Schwimmschule beginnt und endet mit der Übergabe des Kindes an die verantwortliche Kursleitung im vereinbarten Bereich.",
        "Vor und nach dem Unterricht liegt die Aufsichtspflicht bei den Erziehungsberechtigten.",
      ],
    },
    {
      h: "8. Haftung",
      items: [
        "Die Haftung der Schwimmschule Manta richtet sich nach den gesetzlichen Vorschriften. Für Schäden haftet die Schwimmschule bei Vorsatz und grober Fahrlässigkeit. Für persönliche Gegenstände, insbesondere Kleidung, Wertgegenstände oder verlorene Gegenstände, wird keine Haftung übernommen.",
      ],
    },
    {
      h: "9. Fotos und Videos",
      items: [
        "Fotos oder Videos während des Unterrichts werden ausschließlich mit vorheriger ausdrücklicher Einwilligung der Erziehungsberechtigten aufgenommen und ausschließlich zu den vereinbarten Zwecken verwendet. Die Einwilligung kann jederzeit mit Wirkung für die Zukunft widerrufen werden.",
      ],
    },
    {
      h: "10. Mindestteilnehmerzahl",
      items: [
        "Die Schwimmschule Manta behält sich vor, Kurse bei zu geringer Teilnehmerzahl abzusagen oder zusammenzulegen. Bereits gezahlte Kursgebühren werden in diesem Fall vollständig erstattet oder auf Wunsch auf einen anderen Kurs angerechnet.",
      ],
    },
    {
      h: "11. Hausordnung des Schwimmbads",
      items: ["Die Hausordnung des jeweiligen Schwimmbads ist einzuhalten. Den Anweisungen der Kursleitung sowie des Badpersonals ist Folge zu leisten."],
    },
    {
      h: "12. Ausschluss vom Unterricht",
      items: [
        "Teilnehmer, die den Unterricht erheblich stören oder durch ihr Verhalten sich selbst oder andere gefährden, können vom Unterricht ausgeschlossen werden. Ein Anspruch auf Rückerstattung der Kursgebühr besteht in diesem Fall nicht.",
      ],
    },
    {
      h: "13. Datenschutz",
      items: [
        "Die Verarbeitung personenbezogener Daten erfolgt gemäß der Datenschutzerklärung der Schwimmschule Manta. Diese ist auf der Website einsehbar und wird den Erziehungsberechtigten auf Wunsch zur Verfügung gestellt.",
      ],
    },
    {
      h: "14. Schlussbestimmungen",
      items: ["Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt."],
    },
  ],
};
